import apiClient from '../utils/apiClient';

export const getAllAppEvents = async ({
  appId,
  myshopifyDomain,
  dateStart,
  dateEnd,
  eventCategory,
  shopifyPlan,
  country,
  eventPropertiesText,
  noteText,
  domainText,
  sortBy,
  sortOrder,
  page = 1,
  limit = 20,
} = {}) => {
  const params = {
    ...(appId ? { appId } : {}),
    ...(myshopifyDomain ? { myshopifyDomain } : {}),
    ...(dateStart ? { dateStart } : {}),
    ...(dateEnd ? { dateEnd } : {}),
    ...(eventCategory ? { eventCategory } : {}),
    ...(shopifyPlan ? { shopifyPlan } : {}),
    ...(country ? { country } : {}),
    ...(eventPropertiesText ? { eventPropertiesText } : {}),
    ...(noteText ? { noteText } : {}),
    ...(domainText ? { domainText } : {}),
    ...(sortBy ? { sortBy } : {}),
    ...(sortOrder ? { sortOrder } : {}),
    page,
    limit,
  };

  const response = await apiClient.get('/app-events', { params });
  return response.data;
};

export const getAppEventsMerchantsPeriod = async ({
  appId,
  myshopifyDomain,
  shopifyPlan,
  country,
  installStatusCurrent,
  paidStatusCurrent,
  dateStart,
  dateEnd,
  sortBy,
  sortOrder,
  page = 1,
  limit = 20,
} = {}) => {
  const params = {
    ...(appId ? { appId } : {}),
    ...(myshopifyDomain ? { myshopifyDomain } : {}),
    ...(shopifyPlan ? { shopifyPlan } : {}),
    ...(country ? { country } : {}),
    ...(installStatusCurrent ? { installStatusCurrent } : {}),
    ...(paidStatusCurrent ? { paidStatusCurrent } : {}),
    ...(dateStart ? { dateStart } : {}),
    ...(dateEnd ? { dateEnd } : {}),
    ...(sortBy ? { sortBy } : {}),
    ...(sortOrder ? { sortOrder } : {}),
    page,
    limit,
  };
  const response = await apiClient.get('/app-events/merchants-period', { params });
  return response.data;
};

export const getAppEventsEnums = async ({ appId } = {}) => {
  const params = {
    ...(appId ? { appId } : {}),
  };
  const response = await apiClient.get('/app-events/enums', { params });
  return response.data;
};

export const getAppEventsChart = async ({
  appId,
  myshopifyDomain,
  dateStart,
  dateEnd,
  granularity = 'day',
  shopifyPlan,
  country,
} = {}) => {
  const params = {
    ...(appId ? { appId } : {}),
    ...(myshopifyDomain ? { myshopifyDomain } : {}),
    ...(dateStart ? { dateStart } : {}),
    ...(dateEnd ? { dateEnd } : {}),
    granularity,
    ...(shopifyPlan ? { shopifyPlan } : {}),
    ...(country ? { country } : {}),
  };
  const response = await apiClient.get('/app-events/chart', { params });
  return response.data;
};

export const getAppStats = async ({
  appId,
  dateStart,
  dateEnd,
  shopifyPlan,
  country,
  excludeFreePlans,
} = {}) => {
  const params = {
    ...(appId ? { appId } : {}),
    ...(dateStart ? { dateStart } : {}),
    ...(dateEnd ? { dateEnd } : {}),
    ...(shopifyPlan ? { shopifyPlan } : {}),
    ...(country ? { country } : {}),
    ...(excludeFreePlans ? { excludeFreePlans: 'true' } : {}),
  };
  const response = await apiClient.get('/app-events/app-stats', { params });
  return response.data;
};

